import React from 'react'
import { Button, Divider, Typography } from 'antd'
import { CalendarOutlined, CheckCircleOutlined, MessageOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

import { openSupportChat } from '../../util/open-support-chat'

const CALENDLY_URL = 'https://calendly.com/vacation-tracker/vacation-tracker-setup'

interface IMsFeedbackSuccessProps {
  showCalendlyCta: boolean
  onClose: () => void
}

export function MsFeedbackSuccess({ showCalendlyCta, onClose }: IMsFeedbackSuccessProps): JSX.Element {
  const { formatMessage } = useIntl()

  return (
    <div style={{ textAlign: 'center', padding: '8px' }}>
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: 'rgba(124, 58, 237, 0.18)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        <CheckCircleOutlined style={{ fontSize: 28, color: '#7c3aed' }} />
      </div>

      <Typography.Title level={3} style={{ marginTop: 0, marginBottom: showCalendlyCta ? 24 : 8 }}>
        {formatMessage({ id: 'survey.msTrialFeedback.success.title' })}
      </Typography.Title>

      {showCalendlyCta && (
        <>
          <Typography.Title level={5} style={{ marginTop: 0, marginBottom: 4 }}>
            {formatMessage({ id: 'survey.msTrialFeedback.success.helpTitle' })}
          </Typography.Title>
          <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
            {formatMessage({ id: 'survey.msTrialFeedback.success.helpSubtitle' })}
          </Typography.Paragraph>

          <Button type="primary" size="large" block icon={<CalendarOutlined />} href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
            {formatMessage({ id: 'survey.msTrialFeedback.success.calendlyCta' })}
          </Button>

          <Divider plain style={{ margin: '16px 0' }}>
            {formatMessage({ id: 'survey.extendTrial.success.or' })}
          </Divider>

          <Button size="large" block icon={<MessageOutlined />} onClick={() => openSupportChat()}>
            {formatMessage({ id: 'survey.msTrialFeedback.success.chatCta' })}
          </Button>
        </>
      )}

      <Button type="link" onClick={onClose} style={{ marginTop: 16 }}>
        {formatMessage({ id: 'survey.msTrialFeedback.success.backToDashboard' })}
      </Button>
    </div>
  )
}
